import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import { FaCalendarAlt, FaUserTie, FaUsers, FaPlus, FaSearch, FaCheckCircle, FaTimesCircle, FaStar } from "react-icons/fa";

const PatrolRosterManagementPage = () => {
    const [rosters, setRosters] = useState([]);
    const [filteredRosters, setFilteredRosters] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [selectedMember, setSelectedMember] = useState(null);

    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const fetchRosters = async () => {
        setLoading(true);
        try {
            const response = await backEnd_request.get("/PatrolRosters");
            const data = response.data || [];
            setRosters(data);
            setFilteredRosters(data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    // منطق البحث والفلترة
    useEffect(() => {
        const results = rosters.filter(item => {
            const searchLower = searchTerm.toLowerCase();
            const adminName = `${item.user.firstName} ${item.user.lastName}`.toLowerCase();
            const membersNames = item.members.map(m => m.firstName.toLowerCase()).join(" ");

            return item.patrolDate.includes(searchTerm) ||
                adminName.includes(searchLower) ||
                membersNames.includes(searchLower);
        });
        setFilteredRosters(results);
    }, [searchTerm, rosters]);

    const handleDelete = async (id) => {
        if (!window.confirm("هل أنت متأكد من حذف هذه الدورية؟")) return;
        try {
            await backEnd_request.delete(`/PatrolRosters/${id}`);
            fetchRosters();
        } catch (error) {
            console.error("Delete error:", error);
        }
    };

    useEffect(() => {
        fetchRosters();
    }, []);

    return (
        <div className="container-fluid px-lg-5 py-4" dir="rtl" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>

            {/* Header Section */}
            <div className="row mb-4 align-items-center gy-3">
                <div className="col-12 col-md-6">
                    <h2 className="fw-bold text-dark mb-1">
                        <FaCalendarAlt className="ms-2 text-primary" /> سجلات الدوريات
                    </h2>
                    <p className="text-muted mb-0 small">تنظيم ومتابعة طاقم العمليات الميدانية</p>
                </div>
                <div className="col-12 col-md-6 text-md-end">
                    <button
                        className="btn btn-primary shadow-sm px-4 rounded-3 fw-bold d-inline-flex align-items-center"
                        onClick={() => navigate("/admin/patrol-rosters/create")}
                    >
                        <FaPlus className="ml-2" /> إضافة دورية جديدة
                    </button>
                </div>
            </div>

            {/* Stats & Search Bar */}
            <div className="row g-3 mb-4">
                <div className="col-md-7">
                    <div className="input-group shadow-sm rounded-3 overflow-hidden">
                        <span className="input-group-text bg-white border-0"><FaSearch className="text-muted" /></span>
                        <input
                            type="text"
                            className="form-control border-0 py-2"
                            placeholder="ابحث بالتاريخ، اسم المسؤول، أو أحد الأعضاء..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="bg-white p-2 rounded-3 shadow-sm d-flex justify-content-around align-items-center h-100">
                        <div className="text-center">
                            <span className="d-block fw-bold text-primary fs-5">{rosters.length}</span>
                            <small className="text-muted x-small">إجمالي السجلات</small>
                        </div>
                        <div className="vr text-light"></div>
                        <div className="text-center">
                            <span className="d-block fw-bold text-success fs-5">{rosters.filter(r => r.isActive).length}</span>
                            <small className="text-muted x-small">نشطة حالياً</small>
                        </div>
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="d-flex justify-content-center py-5">
                    <div className="spinner-border text-primary" role="status"></div>
                </div>
            ) : (
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                    <div className="card-body p-0">
                        {/* Desktop Table */}
                        <div className="table-responsive d-none d-lg-block">
                            <table className="table table-hover align-middle mb-0 custom-table">
                                <thead className="bg-light">
                                    <tr className="text-secondary small">
                                        <th className="ps-4 py-3">التاريخ</th>
                                        <th>المسؤول المباشر</th>
                                        <th>طاقم الدورية</th>
                                        <th>الحالة</th>
                                        <th className="text-center">الإجراءات</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredRosters.map((item) => (
                                        <tr key={item.patrolRosterId}>
                                            <td className="ps-4 fw-bold text-dark">{item.patrolDate}</td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className="avatar-sm bg-soft-primary text-primary rounded-circle ms-2 d-flex align-items-center justify-content-center fw-bold">
                                                        {item.user.firstName[0]}
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold small">{item.user.firstName} {item.user.lastName}</div>
                                                        <div className="text-muted x-small">@{item.user.username}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-wrap gap-1">
                                                    {item.members.map((m) => (
                                                        <span
                                                            key={m.patrolRosterMemberId}
                                                            className={`badge roster-badge ${m.isLeader ? 'leader' : 'member'}`}
                                                            onClick={() => { setSelectedMember(m); }}
                                                            data-bs-toggle="modal" data-bs-target="#memberModal"
                                                        >
                                                            {m.isLeader && <FaStar className="ms-1" size={10} />}
                                                            {m.firstName}
                                                        </span>
                                                    ))}
                                                </div>
                                            </td>
                                            <td>
                                                {item.isActive ?
                                                    <span className="badge-status active"><FaCheckCircle className="ms-1" /> نشطة</span> :
                                                    <span className="badge-status inactive"><FaTimesCircle className="ms-1" /> ملغاة</span>
                                                }
                                            </td>
                                            <td className="text-center">
                                                <button className="btn btn-sm btn-action text-primary ms-1" onClick={() => navigate(`/admin/patrol-roster/edit/${item.patrolRosterId}`)}>
                                                    <i className="bi bi-pencil-fill"></i>
                                                </button>
                                                <button className="btn btn-sm btn-action text-danger" onClick={() => handleDelete(item.patrolRosterId)}>
                                                    <i className="bi bi-trash-fill"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Mobile Cards View */}
                        <div className="d-lg-none p-3">
                            {filteredRosters.map((item) => (
                                <div key={item.patrolRosterId} className="card border shadow-sm rounded-3 mb-3">
                                    <div className="card-body p-3">
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="fw-bold text-primary">{item.patrolDate}</span>
                                            {item.isActive ? <span className="text-success small">● نشطة</span> : <span className="text-danger small">● ملغاة</span>}
                                        </div>
                                        <div className="mb-3">
                                            <small className="text-muted d-block">المسؤول:</small>
                                            <span className="fw-semibold small">{item.user.firstName} {item.user.lastName}</span>
                                        </div>
                                        <div className="bg-light p-2 rounded-2 mb-3">
                                            <div className="d-flex flex-wrap gap-1">
                                                {item.members.map(m => (
                                                    <span key={m.patrolRosterMemberId} className={`badge roster-badge x-small ${m.isLeader ? 'leader' : 'member'}`}>
                                                        {m.firstName}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <button className="btn btn-outline-primary btn-sm flex-grow-1" onClick={() => navigate(`/admin/patrol-roster/edit/${item.patrolRosterId}`)}>تعديل</button>
                                            <button className="btn btn-outline-danger btn-sm" onClick={() => handleDelete(item.patrolRosterId)}><i className="bi bi-trash"></i></button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {filteredRosters.length === 0 && (
                            <div className="text-center py-5">
                                <FaUsers className="text-light mb-3" size={50} />
                                <p className="text-muted">لا توجد سجلات تطابق بحثك حالياً</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Modal Improved */}
            <div className="modal fade" id="memberModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content border-0 shadow-lg rounded-4">
                        <div className="modal-body p-4 text-center">
                            {selectedMember && (
                                <>
                                    <div className={`avatar-lg mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center ${selectedMember.isLeader ? 'bg-warning-subtle text-warning' : 'bg-primary-subtle text-primary'}`} style={{ width: 70, height: 70 }}>
                                        <FaUserTie size={30} />
                                    </div>
                                    <h5 className="fw-bold mb-1">{selectedMember.firstName} {selectedMember.lastName}</h5>
                                    <p className="text-muted small mb-3">{selectedMember.departmentName || "بدون قسم"}</p>
                                    <div className="bg-light p-3 rounded-3 mb-3">
                                        <div className="d-flex justify-content-between mb-2">
                                            <small className="text-muted">الهاتف:</small>
                                            <small className="fw-bold">{selectedMember.phoneNumber || "---"}</small>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <small className="text-muted">الدور:</small>
                                            <small className={`fw-bold ${selectedMember.isLeader ? 'text-warning' : 'text-primary'}`}>
                                                {selectedMember.isLeader ? 'قائد الدورية' : 'عضو دورية'}
                                            </small>
                                        </div>
                                    </div>
                                    <button className="btn btn-dark w-100 rounded-pill" data-bs-dismiss="modal">إغلاق</button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                .bg-soft-primary { background-color: #e7f1ff; }
                .x-small { font-size: 0.75rem; }
                .roster-badge { 
                    cursor: pointer; 
                    padding: 6px 10px; 
                    border-radius: 6px; 
                    transition: 0.2s;
                    font-weight: 500;
                }
                .roster-badge.leader { background-color: #fff9db; color: #856404; border: 1px solid #ffeeba; }
                .roster-badge.member { background-color: #f8f9fa; color: #495057; border: 1px solid #e9ecef; }
                .roster-badge:hover { transform: translateY(-2px); box-shadow: 0 4px 8px rgba(0,0,0,0.05); }
                
                .badge-status { padding: 5px 12px; border-radius: 20px; font-size: 0.75rem; font-weight: bold; }
                .badge-status.active { background-color: #d4edda; color: #155724; }
                .badge-status.inactive { background-color: #f8d7da; color: #721c24; }
                
                .btn-action { background: none; border: none; padding: 5px 10px; border-radius: 5px; transition: 0.2s; }
                .btn-action:hover { background-color: #f1f1f1; }
                
                .avatar-sm { width: 32px; height: 32px; font-size: 0.8rem; }
                .custom-table tbody tr { transition: 0.2s; }
                .custom-table tbody tr:hover { background-color: #fcfdff !important; }
            `}</style>
        </div>
    );
};

export default PatrolRosterManagementPage;